// extracted by mini-css-extract-plugin
export default {"new_note":"NewNoteUI_new_note__YZpPE","new_note__nav_bar":"NewNoteUI_new_note__nav_bar__gRut2","new_note__body":"NewNoteUI_new_note__body__j7s+9"};